export const HELP_PS_URL = "/docs/PSA/Point_Scaling_Application/Quick_Start/BioPAT_Process_Insights_Overview.htm";
const HELP_RS_PATH_BASE = "/docs/BioPat_Process_Insights_Help/";
export const HELP_RS_URL = `${HELP_RS_PATH_BASE}Content/Featured_content/Home.htm`;
export const HELP_SYSTEM_URL = `${HELP_RS_PATH_BASE}BioPAT_Process_Insights_Help.htm`;
export const ADMIN_PANEL_HELP_URL = `/docs/Admin_Panel/Admin_Panel/Home.htm`;
export var HelpId;
(function (HelpId) {
    HelpId[HelpId["POPULATIONS"] = 1000] = "POPULATIONS";
    HelpId[HelpId["DYNAMICS"] = 1001] = "DYNAMICS";
    HelpId[HelpId["ENVIRONMENT"] = 1002] = "ENVIRONMENT";
    HelpId[HelpId["NEW_DYNAMIC"] = 1003] = "NEW_DYNAMIC";
    HelpId[HelpId["EFFECT_ON_POPULATION"] = 1004] = "EFFECT_ON_POPULATION";
    HelpId[HelpId["DYNAMIC_EFFECT"] = 1005] = "DYNAMIC_EFFECT";
    HelpId[HelpId["DYNAMIC_DEPENDENCY"] = 1006] = "DYNAMIC_DEPENDENCY";
    HelpId[HelpId["NEW_CELL_MODEL"] = 1007] = "NEW_CELL_MODEL";
    HelpId[HelpId["NEW_RECIPE"] = 1008] = "NEW_RECIPE";
    HelpId[HelpId["ADD_STEPS"] = 1009] = "ADD_STEPS";
    HelpId[HelpId["GASES"] = 1010] = "GASES";
    HelpId[HelpId["ADD_LIQUID"] = 1011] = "ADD_LIQUID";
    HelpId[HelpId["ADD_GAS"] = 1012] = "ADD_GAS";
    HelpId[HelpId["RECIPE_PARAMETERS"] = 1013] = "RECIPE_PARAMETERS";
    HelpId[HelpId["CELL_MODELS"] = 1014] = "CELL_MODELS";
    HelpId[HelpId["SIMULATIONS"] = 1015] = "SIMULATIONS";
    HelpId[HelpId["INSIGHTS"] = 1016] = "INSIGHTS";
    HelpId[HelpId["OPTIMIZATIONS"] = 1017] = "OPTIMIZATIONS";
    HelpId[HelpId["RECIPE_WS"] = 1023] = "RECIPE_WS";
    HelpId[HelpId["POPUP_NEW_WS"] = 1024] = "POPUP_NEW_WS";
    HelpId[HelpId["LIQUID"] = 1025] = "LIQUID";
    HelpId[HelpId["NO_AVAILABLE_SEATS"] = 1032] = "NO_AVAILABLE_SEATS";
    HelpId[HelpId["REFINE_CELL_MODEL_PROCESS_DATA"] = 1021] = "REFINE_CELL_MODEL_PROCESS_DATA";
    HelpId[HelpId["REFINE_CELL_MODEL_INPUT_VARIABLE"] = 1030] = "REFINE_CELL_MODEL_INPUT_VARIABLE";
    HelpId[HelpId["REFINE_CELL_MODEL_FITTING_VARIABLE"] = 1031] = "REFINE_CELL_MODEL_FITTING_VARIABLE";
    HelpId[HelpId["REFINE_CELL_MODEL_CM_PARAMETERS"] = 1029] = "REFINE_CELL_MODEL_CM_PARAMETERS";
    HelpId[HelpId["REFINE_VARIABLE_FUNCTIONS"] = 1033] = "REFINE_VARIABLE_FUNCTIONS";
    HelpId[HelpId["CALCULATIONS"] = 1034] = "CALCULATIONS";
    HelpId[HelpId["TABULAR"] = 1035] = "TABULAR";
    HelpId[HelpId["PROCESS_DATA_VIEWER"] = 1036] = "PROCESS_DATA_VIEWER";
    HelpId[HelpId["SPACE_VIEWER"] = 1037] = "SPACE_VIEWER";
    HelpId[HelpId["LINE_GRAPH"] = 1038] = "LINE_GRAPH";
    HelpId[HelpId["RESULTS"] = 1039] = "RESULTS";
    HelpId[HelpId["PROCESS_DATA"] = 1040] = "PROCESS_DATA";
    HelpId[HelpId["PROCESS_DATA_ABOUT"] = 1045] = "PROCESS_DATA_ABOUT";
    HelpId[HelpId["PROCESS_DATA_DOWNLOAD_TIMESERIES"] = 1046] = "PROCESS_DATA_DOWNLOAD_TIMESERIES";
    HelpId[HelpId["PROCESS_DATA_DOWNLOAD_METADATA_PROPERTIES"] = 1047] = "PROCESS_DATA_DOWNLOAD_METADATA_PROPERTIES";
    HelpId[HelpId["PROCESS_DATA_DOWNLOAD_METADATA_LIQUIDS"] = 1048] = "PROCESS_DATA_DOWNLOAD_METADATA_LIQUIDS";
    HelpId[HelpId["PROCESS_DATA_IMPORT"] = 1049] = "PROCESS_DATA_IMPORT";
    HelpId[HelpId["INSIGHTS_OPERATIONS"] = 1050] = "INSIGHTS_OPERATIONS";
    HelpId[HelpId["INSIGHTS_TRANSFORMATION"] = 1051] = "INSIGHTS_TRANSFORMATION";
    HelpId[HelpId["INSIGHTS_TIMEFRAME"] = 1052] = "INSIGHTS_TIMEFRAME";
    HelpId[HelpId["RECIPE_INPUT_METHODS"] = 1053] = "RECIPE_INPUT_METHODS";
    HelpId[HelpId["EMPTY_RECIPE"] = 1056] = "EMPTY_RECIPE";
    HelpId[HelpId["EDIT_CONNECTED_OBJECTS"] = 1057] = "EDIT_CONNECTED_OBJECTS";
    HelpId[HelpId["ASSIGNING_FUNCTIONS_TO_PROCESS_VARIABLES"] = 1058] = "ASSIGNING_FUNCTIONS_TO_PROCESS_VARIABLES";
    HelpId[HelpId["REFINEMENT_ACCURACY"] = 1059] = "REFINEMENT_ACCURACY";
    HelpId[HelpId["CUSTOM_VARIABLES"] = 1061] = "CUSTOM_VARIABLES";
    HelpId[HelpId["RECIPE_WITH_ALTERNATIVE_FLOWS"] = 1062] = "RECIPE_WITH_ALTERNATIVE_FLOWS";
})(HelpId || (HelpId = {}));
